module.exports = __webpack_public_path__ + "media/images/application/icons/arrow-select-language-175a723f706d45ca310df66111508a03.svg";